import apiClient from '../client'
import type { PageResponse } from '../types'
import type { ImportBatchResponse, ImportErrorResponse, OcrCaseSummaryResponse } from './types'

export const importBatchesApi = {
  list(params?: {
    importNo?: string
    importType?: string
    status?: string
    dateFrom?: string
    dateTo?: string
    excludeDeleted?: boolean
    sortBy?: string
    order?: 'ASC' | 'DESC'
    page?: number
    size?: number
  }) {
    return apiClient.get<PageResponse<ImportBatchResponse>>('/api/import-batches', { params })
  },

  getById(id: number) {
    return apiClient.get<ImportBatchResponse>(`/api/import-batches/${id}`)
  },

  getErrors(id: number) {
    return apiClient.get<ImportErrorResponse[]>(`/api/import-batches/${id}/errors`)
  },

  confirm(id: number) {
    return apiClient.post<ImportBatchResponse>(`/api/import-batches/${id}/confirm`)
  },

  delete(id: number) {
    return apiClient.delete<{ message: string }>(`/api/import-batches/${id}`)
  },

  download(id: number) {
    return apiClient.get(`/api/import-batches/${id}/download`, { responseType: 'blob' })
  },

  fixErrors(batchId: number, rows: { lineNo: number; cells: string[] }[]) {
    return apiClient.put<ImportBatchResponse>(`/api/import-batches/${batchId}/fix-errors`, { rows })
  },

  upload(file: File, mappingKey?: string, mappingJson?: string) {
    const formData = new FormData()
    formData.append('file', file)
    if (mappingKey) {
      formData.append('mappingKey', mappingKey)
    }
    if (mappingJson) {
      formData.append('mappingJson', mappingJson)
    }
    // バックエンドは createPendingBatch まで（IMPORTING 状態）で即応答するため、
    // デフォルト timeout (30s) で十分。残り処理は非同期スレッドで継続する。
    return apiClient.post<ImportBatchResponse>('/api/import-batches/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },

  ocrUpload(file: File) {
    const formData = new FormData()
    formData.append('file', file)
    return apiClient.post<ImportBatchResponse>('/api/import-batches/ocr-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 600_000,
    })
  },

  listOcrCases(batchId: number) {
    return apiClient.get<OcrCaseSummaryResponse[]>(`/api/import-batches/${batchId}/ocr-cases`)
  },
}
